import React from "react";
import strings from "../config/localization";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

interface Props {
  title?: string;
  msg: string;
}

export default function ErrorMsg({ title = strings.error, msg }: Props) {
  return (
    <Alert severity="error" sx={{ whiteSpace: "pre-line" }}>
      <AlertTitle>{title}</AlertTitle>
      {msg}
    </Alert>
  );
}
